'use client';

import { memo, Suspense, useMemo } from 'react';

import Image from 'next/image';

import footer from '@/features/v2/shared/footer/localization/core';

import HCarousel from '@/stories/organisms/carousel/hcarousel/Hcarousel';

const AlliesSkeleton = memo(() => {
  return (
    <div className="flex justify-center items-center gap-4" role="status" aria-label="Cargando aliados">
      {Array.from({ length: 4 }, (_, index) => {
        return (
          <div key={`ally-skeleton-${index}`} className="w-24 h-24 bg-default-200 rounded-lg animate-pulse" />
        );
      })}
    </div>
  );
});

const AlliesContent = memo(() => {
  const allyItems = useMemo(() => {
    return footer.footer.map((ally, index) => {
      return (
        <div key={`ally-${ally.name}-${index}`} className="w-28 h-10 flex justify-center items-center">
          <Image
            className="object-contain h-[20px] w-[100px]"
            src={ally.image}
            alt={ally.name}
            width={100}
            height={20}
            loading="lazy"
            quality={70}
            draggable={false}
          />
        </div>
      );
    });
  }, []);

  return (
    <div role="region" aria-label="Aliados" className="w-full max-w-3xl mx-auto">
      <HCarousel
        items={allyItems}
        autoPlay
        animated
        opts={{
          align: 'start',
          mobileAlign: 'start',
          active: true,
          duration: 0.1,
        }}
      />
    </div>
  );
});

const AlliesSection = () => {
  return (
    <section className="flex flex-col gap-4 justify-center items-center mt-4 md:mt-6 mx-4">
      <header>
        <h2 className="text-xl md:text-2xl font-bold text-white">ALIADOS</h2>
      </header>

      <Suspense fallback={<AlliesSkeleton />}>
        <AlliesContent />
      </Suspense>
    </section>
  );
};

export default memo(AlliesSection);
